export class OtherDevices {

    constructor(store) {

        this.store = store;

        this.container = document.createElement("div");

        Object.assign(this.container.style, {
            width: "100%",
            height: "100%",
            padding: "20px",
            boxSizing: "border-box",
            color: "white",
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
            lineHeight: "1.5",
            overflowY: "auto"
        });

    }

    render() {

        this.container.innerHTML = "";

        const title = document.createElement("h2");
        title.textContent = "Egyéb eszközök";

        this.container.appendChild(title);

        this.store.level.otherDevices.forEach(device => {

            const row = document.createElement("div");

            row.className = "other-device";

            row.style.padding = "10px 12px";
            row.style.cursor = "pointer";
            row.style.transition = "background .2s ease";

            row.innerHTML = `
                <strong>${device.category}</strong><br>
                ${device.barcode}
            `;

            row.addEventListener("mouseenter", () => {
                row.style.background = "rgba(255,245,160,.25)";
            });

            row.addEventListener("mouseleave", () => {
                row.style.background = "transparent";
            });

            row.addEventListener("click", () => {

                this.store.modalController.showInventoryForm(device);

            });

            this.container.appendChild(row);

        });

        return this.container;
    }

}